import type { TFunction } from 'i18next';

/** Localized product type; falls back to raw API value if key missing. */
export function productTypeLabel(t: TFunction, type: string): string {
  const key = `masterData.productType.${type}`;
  const translated = t(key);
  return translated === key ? type : translated;
}
